<div class="d-flex gap-3 flex-column">
    <div class="d-flex flex-column w-100 align-items-start gap-4" [ngClass]="{'flex-md-row align-items-md-center': isResponsive}">
        <label class="small d-flex flex-row text-nowrap" [ngStyle]="{'width': width}">
            {{label}}
            <span *ngIf="control.hasError('required')" style="color: red;">*</span>
        </label>
        <app-datepicker1 [control]="control" [placeholder]="placeholder" class="flex-grow-1 w-100"></app-datepicker1>
    </div>
    <div class="d-flex flex-row w-100 align-items-center justify-content-end">
        <span class="error-label" *ngIf="isInvalid()">
            {{errorMessage}}
        </span>
    </div>
</div>